<template>
  <v-container>
    <p>Loading...</p>
  </v-container>
</template>

<script>
export default {
  mounted: function () {
    // Redirect the user based on their role
    if (!this.$auth.check()) {
      this.$router.push('/login')
    } else {
      let role = this.$auth.user().roles

      switch (role) {
        case 'admin':
          this.$router.push('/admin')
          break
        case 'church-member':
          this.$router.push('/devotional')
          break
        default:
          this.$router.push('/account')
          break
      }
    }
  }
}
</script>
